import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css'
import '../assets/main.scss'
import '../assets/transitions.css'

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0000FF',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#377dff', // '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            }
        },
    },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
})

export default vuetify
